'use client';
import { useState } from 'react';
type Group = { name: string; items: { question: string; answer: string }[] };
export function FaqSearch({ groups }: { groups: Group[] }) {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('All topics');
  const needle = query.trim().toLocaleLowerCase();
  const visible = groups
    .filter((g) => category === 'All topics' || g.name === category)
    .map((g) => ({
      ...g,
      items: g.items.filter((i) =>
        `${i.question} ${i.answer}`.toLocaleLowerCase().includes(needle)
      ),
    }))
    .filter((g) => g.items.length);
  const count = visible.reduce((n, g) => n + g.items.length, 0);
  return (
    <section className="mx-auto max-w-[1240px] px-5 pb-12 lg:px-8">
      <div className="grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-5 sm:grid-cols-[1fr_auto]">
        <label className="text-sm font-semibold">
          Search questions
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Try payroll, leave or access"
            className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm font-normal"
          />
        </label>
        <label className="text-sm font-semibold">
          Topic
          <select
            aria-label="Topic"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="mt-2 block w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm font-normal"
          >
            <option>All topics</option>
            {groups.map((g) => (
              <option key={g.name}>{g.name}</option>
            ))}
          </select>
        </label>
      </div>
      <p role="status" className="mt-4 text-sm text-slate-600">
        {count} {count === 1 ? 'answer' : 'answers'} found
      </p>
      {count === 0 && (
        <div className="mt-6 rounded-xl border border-slate-200 p-6">
          <h2 className="font-semibold">No matching questions</h2>
          <p className="mt-2 text-sm text-slate-600">
            Try a shorter search or choose a different topic.
          </p>
          <button
            type="button"
            onClick={() => {
              setQuery('');
              setCategory('All topics');
            }}
            className="mt-4 text-sm font-semibold text-orange-700"
          >
            Clear search and topic
          </button>
        </div>
      )}
      <div className="mt-7 grid gap-8 lg:grid-cols-2">
        {visible.map((g) => (
          <section key={g.name}>
            <h2 className="mb-3 text-xl font-bold">{g.name}</h2>
            <div className="divide-y divide-slate-200 border-y border-slate-200">
              {g.items.map((item) => (
                <details key={item.question} className="py-4">
                  <summary className="text-sm font-semibold leading-7">{item.question}</summary>
                  <p className="mt-3 text-sm leading-7 text-slate-600">{item.answer}</p>
                </details>
              ))}
            </div>
          </section>
        ))}
      </div>
    </section>
  );
}
